export function scrollDirection() {
  const header = document.querySelector('.header');
  let hh = 0;
  const gethh = () => {
    if(header){
      hh = header.clientHeight;
    }
  }
  let prevScrollpos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  let currentScTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  const SCROLL_HEADER_SHOWHIDE = () => {
    const currentScrollPos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    if(!document.body.classList.contains('is-disable-scroll-direction')) {
      if(currentScTop < currentScrollPos || currentScrollPos < currentScTop) {
        if (currentScrollPos >= hh) {
          document.body.classList.add('is-scrolled');
          if (prevScrollpos < currentScrollPos) {
            document.body.classList.add('dir-bottom');
          } else {
            document.body.classList.remove('dir-bottom');
          }
        } else {
          document.body.classList.remove('is-scrolled');
        }
      }
    }
    prevScrollpos = currentScrollPos;
  }
  gethh();
  SCROLL_HEADER_SHOWHIDE();
  document.addEventListener('DOMContentLoaded', SCROLL_HEADER_SHOWHIDE);
  window.addEventListener("scroll", SCROLL_HEADER_SHOWHIDE);
  let lastInnerWidth = window.innerWidth;
  let resizeSto = ''
  window.addEventListener("resize", function () {
    this.clearTimeout(resizeSto);
    resizeSto = setTimeout(() => {
      if(lastInnerWidth != window.innerWidth) {
        lastInnerWidth = window.innerWidth;
        gethh();
      }
    }, 300)
  });
}